export default __webpack_public_path__ + "static/media/Finalized.9ecf6101.svg";